import { useQuery } from '@tanstack/react-query';
import { promotionsService } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';

/**
 * Home 화면용 promotion 컴포넌트 (floating buttons / banners) 조회.
 * iOS HomeTodayReactor.fetchPromotion(screen=.today, goodsSNO=nil) 와 대응.
 */
export const useHomePromotionComponents = () => {
  return useQuery({
    queryKey: queryKey.homePromotionComponents(),
    queryFn: () => promotionsService.getPromotionsComponents(null, 'TODAY'),
  });
};
